import React, { useEffect, useState } from "react";
import EventCard from "./EventCard";
import { Link } from "react-router";
import Header from "./Header";

function EventCalendar() {
  const [event, setEvent] = useState([]);

  useEffect(() => {
    fetch("/api/events/")
      .then((res) => res.json())
      .then(setEvent);
  }, []);

  return (
    <div>
      <Header />

      <div className="mt-8">
        {event && event.length > 0 ? (
          <div>
            <p className="mt-4 text-base text-pretty text-gray-700 sm:text-lg/relaxed p-4">
              Discover upcoming KEBS-hosted conferences, workshops, and training
              programmes designed to enhance standards, innovation, quality, and
              excellence across industries.
              <span className="font-bold ml-2 text-[#0166b1]">
                Click on an event to view full details and register.
              </span>
            </p>

            {event.map((item) => (
              <Link
                className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3"
                key={item.id}
                to={`/events/${item.event_slug}`}
              >
                <EventCard event={item} />
              </Link>
            ))}
          </div>
        ) : (
          <div className="mt-5 mx-auto col-span-full max-w-md">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke-width="1.5"
              stroke="currentColor"
              className="mx-auto size-20 text-gray-400"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M6.75 3v2.25m10.5-2.25V5.25M3.75 9.75h16.5M4.5 6.75h15a1.5 1.5 0 011.5 1.5v10.5a1.5 1.5 0 01-1.5 1.5h-15a1.5 1.5 0 01-1.5-1.5V8.25a1.5 1.5 0 011.5-1.5zM8.25 14.25h.008v.008H8.25v-.008zM12 14.25h.008v.008H12v-.008zM15.75 14.25h.008v.008h-.008v-.008z"
              ></path>
            </svg>

            <h2 className="mt-6 text-2xl font-bold text-gray-900">
              No Upcoming Events Scheduled
            </h2>

            <p className="mt-4 text-pretty text-gray-700">
              KEBS regularly hosts conferences, workshops, and training
              programmes. New events will be published here as they are
              announced.
            </p>

            <p className="mt-2 text-pretty text-gray-700">
              Explore previous KEBS events and workshops for reference and
              materials.
            </p>

            <button
              type="button"
              className="mt-6 block  bg-[#0166b1] w-full rounded-lg px-6 py-3 text-sm font-medium text-white transition-colors hover:bg-indigo-700"
            >
              View Past Events
            </button>
            <p className="text-sm mt-2 text-gray-600">
              📢 Follow KEBS channels for announcements on
              upcoming events.
            </p>
          </div>
        )}
      </div>
    </div>
  );
}

export default EventCalendar;
